import BaseFormPage from "../../../../base/BaseFormPage";
import { InputJson, Button } from "nq-component";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import ViewPayrollFormPresenter from "./ViewPayrollFormPresenter";
import NavBar from "../../../../components/NavBar";
import withRouter from "../../../../withRouter";
import PayrollTablePage from "./PayrollTablePage";
import FormFooter from "../../Payroll/form-payroll/form-footer/FormFooter";
import { Spin } from "antd";

class ViewPayrollFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      loading: true,
      payrollHeader: null,
      signatories: {
        sectionName_1: "RHUBIE M. TAMAYO",
        sectionPos_1: "Acting Chief, Compensation & Employee Benefits Unit",
        sectionName_2: "CHESTER KEVIN S. SY",
        sectionPos_2: "Chief, Accounting Section",
        sectionName_3: "MARIA JOANA VICTORIA L. MAGLAY",
        sectionPos_3: "Division Chief, PBD",
        sectionName_4: "LILIBETH F. LINTAG",
        sectionPos_4: "Disbursing Officer",
      },
      year: "",
    };
    this.presenter = new ViewPayrollFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  componentDidMount() {
    super.componentDidMount();
    this._loadPayrollHeader();
  }

  async _loadPayrollHeader() {
    try {
      const payrollLayouts = await findObjectUseCase().execute(
        "payroll_layouts",
        {
          keys: ["footer", "header", "name"],
        }
      );

      this.setState({
        payrollHeader: payrollLayouts?.[0]
          ? { value: payrollLayouts[0] }
          : null,
      });
    } catch (error) {
      console.error("Failed to load payroll header:", error);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      if(this.state.object.payItem === "20% Monthly Premium"){
        const payrollData = await this.fetchPayrollData(this.state.object.id);
        this.setState({ year: payrollData?.[0]?.year ?? "" });
      }
      this.setState({ loading: false });
    }
  }

  async fetchPayrollData (payrollID){
    return await findObjectUseCase().execute("payroll", {
      where: {
        payrollID
      }
    });
}

  getCollectionName() {
    return "payroll_list";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  render() {
    const { object, loading, advanced, signatories, payrollHeader, year } = this.state;
    const isBackPay = this.getArgument().object.isBackpay;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    return (
      <>

        <div className="overflow-auto mt-5">
          <div className="h-100 mt-4">
            <div className="p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"} {""}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <div className="bg-white shadow rounded p-3 ">
                <div
                  className="d-flex justify-content-end gap-2"
                  style={{ marginLeft: "auto" }}
                >
                  <Button
                    className="btn btn-primary"
                    onClick={this.onClickBack.bind(this)}
                  >
                    <i className="bi bi-arrow-return-left" />
                  </Button>
                </div>
                <br></br>
                {this.presenter._renderLogoHeader(payrollHeader)}
                <p className="text-center m-0 pt-3">
                  {this.presenter._renderDateRange(object, year)}
                </p>
                <p className="text-center m-0 fw-bold">
                  {this.presenter._renderPayrollTrail(object)}
                </p>
                <br></br>
                <div className="row p-2">
                  {advanced ? (
                    <InputJson
                      defaultValue={object}
                      onChange={this.onChangeObject.bind(this)}
                      rows="15"
                    />
                  ) : (
                    <>
                      <div className="p-0 table-wrapper">
                        {loading ? (
                          <div
                            className="d-flex justify-content-center align-items-center w-100"
                            style={{ minHeight: "200px" }}
                          >
                            <Spin size="large" />
                          </div>
                        ) : (
                          <div
                            style={{
                              opacity: 0,
                              animation: "fadeIn 0.4s ease-in-out forwards",
                            }}
                          >
                            {Object.keys(object).length > 0 && (
                              <PayrollTablePage
                                object={object}
                                formData={{
                                  signatories: signatories,
                                  isBackPay,
                                  payrollHeader,
                                }}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className="mt-3 mb-2">
                  <FormFooter
                    signatories={signatories}
                    fontSize="12px"
                    width="95%"
                    onNameChange={this.presenter._onSignatoryChange}
                    onPositionChange={this.presenter._onSignatoryChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ViewPayrollFormPage);
